import { smashBlocks } from './blocks';

export const getBlockById = (id) =>
    smashBlocks.find((item) => item.id === id) || null;

export const buildCustomizerUrl = (customizerPage, feedId) =>
    `admin.php?page=${customizerPage}&feed_id=${feedId}`;

export const primaryButtonStyle = {
    background: '#0068A0',
    color: '#fff',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    padding: '6px 12px',
    borderRadius: '2px',
    textDecoration: 'none',
    fontSize: '13px',
    fontWeight: '500',
};
